"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
let RegisterSuccess = class extends Vue {
  constructor() {
    super(...arguments);
    this.teamName = null;
    this.teamCode = null;
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query.hasOwnProperty("code")) {
        this.teamCode = this.$route.query.code;
      } else {
        this.$router.push("/");
        return;
      }
      yield this.getTeamName();
    });
  }
  getTeamName() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.app/api/v1/team/code/${this.teamCode}`
        );
        this.teamName = response.data.name;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  toDownload() {
    window.open(`https://www.kuajingvs.com/download`);
  }
};
RegisterSuccess = __decorateClass([
  Component({
    components: {}
  })
], RegisterSuccess);
export {
  RegisterSuccess as default
};
